import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import Brand from 'models/brand';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  lowerContentPresent: PropTypes.bool,
};

const defaultProps = {
  lowerContentPresent: false,
};

const PartnerNotice = ({ brand, lowerContentPresent }) => {
  if (!brand.isBestParking) { return null; }

  const noticeClasses = cx({
    'text-weight-bold': true,
    'text-size-12': true,
    'text-center': true,
    'padding-10': true,
    'margin-bottom-20': lowerContentPresent,
    'margin-horizontal-40': true,
    'margin-bottom-negative-20': !lowerContentPresent,
    'margin-left-sm-0': true,
    'margin-bottom-sm-0': true,
    'margin-right-sm-80': true,
    'background-color-watermelon': true,
    'background-color-print-black': true,
  });

  return (
    <div className={noticeClasses}>
      <div className="background-color-print-black text-color-print-white">
        <FormattedMessage
          id="parking-pass.attendant-note"
          defaultMessage="Note for Attendant:"
        />
      </div>
      <div className="background-color-print-black text-color-print-white">
        <FormattedMessage
          id="parking-pass.process-as-parkwhiz"
          defaultMessage="Process as a ParkWhiz Pass"
        />
      </div>
    </div>
  );
};

PartnerNotice.propTypes = propTypes;
PartnerNotice.defaultProps = defaultProps;
export default PartnerNotice;
